<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <table class="hiaTable">
      <thead>
        <tr>
          <th>Auditor</th>
          <th>Total Records</th>
          <th>Records With Findings</th>
          <th>Coder Agrees</th>
          <th>Upheld Recommendation</th>
          <th>Recommendation Changed - Additional Documentation Provided</th>
          <th>Recommendation Changed - Department Policy</th>
          <th>Recommendation Changed - Payor Specific Guidelines</th>
          <th>Recommendation Changed - Auditor Agrees</th>
        </tr>
      </thead>
      <tr v-for="(row, i) in tableData" :key="i">
        <td class="textAlignLeft">{{ row.auditor }}</td>
        <td>{{ row.totalRecords }}</td>
        <td>{{ row.recordsWithFindings }}</td>
        <td>{{ row.coderAgrees }}</td>
        <td>{{ row.outcome1 }}</td>
        <td>{{ row.outcome2 }}</td>
        <td>{{ row.outcome3 }}</td>
        <td>{{ row.outcome4 }}</td>
        <td>{{ row.outcome5 }}</td>
      </tr>
      <tr class="strong emphasis" v-if="tableData.length > 0">
        <td class="textAlignLeft">Totals</td>
        <td>{{ summary[1] }}</td>
        <td>{{ summary[2] }}</td>
        <td>{{ summary[3] }}</td>
        <td>{{ summary[4] }}</td>
        <td>{{ summary[5] }}</td>
        <td>{{ summary[6] }}</td>
        <td>{{ summary[7] }}</td>
        <td>{{ summary[8] }}</td>
      </tr>
      <tr v-if="tableData.length === 0">
        <td colspan="9">{{ loading ? 'loading...' : 'No Rebuttal Data Found' }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import axios from '@/utilities/axios-global'
  import { mapState } from 'vuex'
  import dashboardHelper from '@/mixins/dashboardHelper'

  export default {
    name: 'IPRebuttalsByAuditorPrintable',
    mixins: [dashboardHelper],
    props: ['drgTableIds'],
    data: function() {
      return {
        tableData: [],
        loading: false
      }
    },
    methods: {
      async getData() {
        const payload = {
          drgTableIds: this.drgTableIds
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/dashboard/inpatientRebuttalOutcomesByAuditor`, payload)
          this.tableData = response.data
        } catch (err) {
          this.tableData = []
        } finally {
          this.loading = false
        }
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      summary: function() {
        const param = {
          columns: [{ property: 'auditor' }, { property: 'totalRecords' }, { property: 'recordsWithFindings' }, { property: 'coderAgrees' }, { property: 'outcome1' }, { property: 'outcome2' }, { property: 'outcome3' }, { property: 'outcome4' }, { property: 'outcome5' }],
          data: this.tableData
        }
        return this.getSummary(param)
      }
    },
    mounted: async function() {
      await this.getData()
    },
    watch: {
      drgTableIds: async function() {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
  .hiaTable thead th {
    text-align: center;
  }

  .hiaTable tr td {
    text-align: right;
  }
</style>
